import { GetMeResponse, LanguageItem, RegionalInfo } from '@shared/interfaces/users/users.interface';
import { Maybe } from '@shared/types';
import { BalanceInfoFull } from '@shared/interfaces/users/balance-info-full';
import { OrderHistoryViewId, OrderHistoryViewType } from '../../modules/orders/interfaces/order-models';
import { environment } from '../../../environments/environment';
import { BUILD_DEFAULTS } from '../../../environments/environment-files/build-defaults.const';

export interface UserState {
  user: GetMeResponse | null;
  isUserLoading: boolean;
  balanceInfo: Maybe<BalanceInfoFull>;
  isBalanceInfoLoading: boolean;
  balanceInfoContractId: string | null;
  language: LanguageItem;
  regionalInfo: RegionalInfo;
  orderHistoryViewType: OrderHistoryViewId;
}

const buildDefaults = BUILD_DEFAULTS[environment.build];

export const initialState: UserState = {
  user: null,
  isUserLoading: false,
  balanceInfo: null,
  isBalanceInfoLoading: false,
  balanceInfoContractId: null,
  language: {
    id: 0,
    name: buildDefaults.languageName,
    description: buildDefaults.locale,
  },
  regionalInfo: {
    culture: buildDefaults.locale,
    currency: buildDefaults.currency,
    phonePattern: buildDefaults.phonePattern,
  },
  orderHistoryViewType: {
    id: OrderHistoryViewType.Collapsed,
  },
};
